(function () {
  'use strict';

  function init(root) {
    var steps = root.querySelectorAll('[data-quiz-step]');
    var results = root.querySelectorAll('[data-quiz-result]');
    var card = root.querySelector('.slp-path-quiz__card');
    var footer = root.querySelector('[data-quiz-footer]');
    if (!steps.length || !card) return;

    var current = 0;

    function showQuestionStep(index) {
      current = index;
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = i !== index;
      }
      for (var j = 0; j < results.length; j++) {
        results[j].hidden = true;
      }
      if (footer) footer.hidden = true;
      card.hidden = false;

      var active = root.querySelector('[data-quiz-step="' + index + '"]');
      if (active) {
        var heading = active.querySelector('.slp-path-quiz__question');
        if (heading && typeof heading.focus === 'function') {
          heading.focus({ preventScroll: true });
        }
      }
    }

    function showResult(key) {
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = true;
      }
      for (var j = 0; j < results.length; j++) {
        results[j].hidden = results[j].getAttribute('data-quiz-result') !== key;
      }
      if (footer) footer.hidden = false;

      var resEl = root.querySelector('[data-quiz-result="' + key + '"]');
      if (resEl) {
        var rh = resEl.querySelector('.slp-path-quiz__result-heading');
        if (rh && typeof rh.focus === 'function') {
          rh.focus({ preventScroll: true });
        }
      }
    }

    root.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (current < 2) {
          showQuestionStep(current + 1);
        }
      });
    });

    root.querySelectorAll('[data-quiz-result-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pick = btn.getAttribute('data-quiz-result-pick');
        if (pick) showResult(pick);
      });
    });

    root.querySelectorAll('[data-quiz-reset]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        showQuestionStep(0);
      });
    });

    showQuestionStep(0);
  }

  document.querySelectorAll('[data-path-quiz]').forEach(init);
})();
